import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-table-mobile',
  templateUrl: './pricing-table-mobile.component.html',
  styleUrls: ['./pricing-table-mobile.component.scss']
})
export class PricingTableMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
